import React from 'react'
import { overlayContainer, column, link } from './styles'
import ExternalLink from 'components/external-link.js'
import paths from 'data/paths.json'

export default function NavAccount() {
    return <div css={overlayContainer(4)}>
        <div css={column}>
            <ExternalLink
                to={paths.external.account}
                className='d-flex a-center g-1'
                css={link}
            >
                inMusic Account
                <img src='/svg/external-link-black.svg' alt='' />
            </ExternalLink>
            <ExternalLink
                to={paths.external.login}
                className='d-flex a-center g-1'
                css={link}
            >
                Sign In
                <img src='/svg/external-link-black.svg' alt='' />
            </ExternalLink>
        </div>
        <div
            className='j-end'
            css={column}
        >
            <ExternalLink
                to={paths.external.create}
                className='d-flex a-center g-1'
                css={link}
            >
                Register
                <img src='/svg/external-link-black.svg' alt='' />
            </ExternalLink>
        </div>
    </div>
}
